export const API_BASE_URLS = {
  BASE_URL: import.meta.env.VITE_BASE_API_URL,
} as const;
